import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

import womanWithMagnifyingGlass from '@images/woman-with-magnify-glass.png'

const UnscoredTableNoResults = () => {
    return (
        <Flex gridColumn="1/13" justifyContent="center">
            <Flex justifyContent="center" pr="space30">
                <Image
                    src={womanWithMagnifyingGlass}
                    alt="Woman holding a magnifying glass"
                    width="100"
                    height="100"
                    priority={true}
                />
            </Flex>
            <Flex justifyContent="center" flexDirection="column">
                <Box mb="space05">
                    <Heading variant="60">
                        Sorry, we couldn&apos;t find any cards for this category
                    </Heading>
                </Box>
                <Text variant="100" color="light">
                    Please select another category
                </Text>
            </Flex>
        </Flex>
    )
}

export default UnscoredTableNoResults
